module.exports = __webpack_public_path__ + "static/img/janus02.a8224a73.png";